<template>
  <v-container fluid>
    <v-row justify="center" class="mt-n8">
      <v-icon class="mx-2" size="35px">account_balance</v-icon>

      <span style="font-size: 34px; color: #616161">Secuencia cheques</span>
    </v-row>

    <v-row justify="center" class="mt-3">
      <v-col cols="12" md="12">
        <v-row justify="center">
          <search-header
            :show_department="false"
            :show_location="false"
            :show_accounts="true"
            :select_week="2"
            :showAdditionalFilter="true"
            :show_weeks="false"
            @dataFilters="get_data($event)"
          >
          </search-header>
        </v-row>
      </v-col>
    </v-row>
    <v-row justify="center" class="mt-n6">
      <v-col cols="12">
        <v-row no-gutters justify="start"> </v-row>
        <v-row v-if="loading" justify="center">
          <v-col cols="12" md="10">
            <v-skeleton-loader
              type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"
            >
            </v-skeleton-loader>
          </v-col>
        </v-row>

        <v-data-table
          v-else
          :search="search"
          :headers="headers"
          :items="all_sequence_account"
          dense
          class="elevation-0 mt-2"
        >
          <template v-slot:top>
            <v-toolbar class="elevation-0 rounded-lg">
              <v-toolbar-title>Secuencias</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field
                label="Buscar..."
                class="mt-6"
                v-model="search"
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn v-if="hasFeature('CXP-032')" @click="openTestPrinter" small class="mx-2" color="secondary" outlined>
                <v-icon class="mx-1">print</v-icon> Probar impresora
              </v-btn>
              <v-btn v-if="hasFeature('CXP-032')" @click="showAddSequence" small class="mx-2" color="primary" outlined>
                <v-icon class="mx-1">payments</v-icon> Nueva secuencia
              </v-btn>
            </v-toolbar>
          </template>

          <template v-slot:[`item.sequence`]="{ item }">
            {{ item.sequence }}
            <v-chip v-if="item.cancelled" x-small color="red" text-color="white" class="ml-1">
              Anulado
            </v-chip>
          </template>
          <template v-slot:[`item.payment_transaction_id`]="{ item }">
            <a
              v-if="item.payment_transaction_id"
              style="text-decoration: underline; cursor: pointer"
              @click="goToTransaction(item.payment_transaction_id)"
            >
              {{ item.payment_transaction_id }}
            </a>
            <v-chip
              v-if="item.transaction_status_id"
              x-small
              :color="getStatusColor(item.transaction_status_id)"
              text-color="white"
              class="ml-1"
            >
              {{ item.transaction_status_name }}
            </v-chip>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              v-if="item.status_id == 1 && hasFeature('CXP-032')"
              @click="(dialogCancelPayment = true), (selectPayments = item)"
              color="red"
              class="mx-2 mt-n2"
            >
              cancel
            </v-icon>
          </template>
          <template slot="no-data">
            <h1 v-if="lastData">
              {{
                lastData.accountBank == null
                  ? "Selecciona una cuenta de banco"
                  : "No hay secuencias, en esta cuenta de banco"
              }}
            </h1>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-- Prueba / calibración de impresora -->
    <v-dialog v-model="testDialog" width="640px" persistent>
      <v-card>
        <v-card-title class="text-h6">
          <v-icon class="mr-2">print</v-icon> Probar impresora de cheques
          <v-spacer></v-spacer>
          <v-btn icon @click="testDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text class="pt-4">
          <v-row dense>
            <v-col cols="12">
              <v-alert v-if="lastData && lastData.accountBank" dense text type="info" class="mb-2 text-caption">
                Configurando la cuenta seleccionada. "Guardar" la deja fija para esa cuenta.
              </v-alert>
              <v-alert v-else dense text type="warning" class="mb-2 text-caption">
                Sin cuenta seleccionada: se guardará solo localmente. Selecciona una cuenta arriba para guardarla en la cuenta.
              </v-alert>
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="test.bankType"
                :items="bankTypes"
                dense
                outlined
                label="Plantilla de cheque"
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="printApiUrl" dense outlined label="Servicio de impresión (este equipo)"
                placeholder="http://localhost:5000/" hint="Vacío = valor por defecto" persistent-hint
                append-icon="mdi-content-save-outline" @click:append="savePrintApiUrl"
                @keydown.enter="savePrintApiUrl"></v-text-field>
            </v-col>
            <v-col cols="12">
              <printer-picker v-if="testDialog" ref="printerPicker" v-model="test.printerName"></printer-picker>
            </v-col>

            <v-col cols="6">
              <v-text-field v-model.number="test.copies" type="number" min="1" max="50" step="1" dense outlined
                label="Cantidad de cheques"></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model.number="test.rows" type="number" min="0" max="100" step="1" dense outlined
                label="Filas de facturas por cheque"></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model.number="test.amountMin" type="number" min="1" dense outlined
                label="Monto mínimo por factura" hint="Cada factura sale con un monto al azar en el rango"
                persistent-hint></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model.number="test.amountMax" type="number" min="1" dense outlined
                label="Monto máximo por factura" hint="El cheque = suma de sus facturas" persistent-hint></v-text-field>
            </v-col>

            <v-col cols="12">
              <div class="text-caption grey--text mb-1">
                Calibración (1/100"). Ajusta y reimprime hasta que caiga en las casillas.
              </div>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model.number="test.offsetX" type="number" dense outlined
                label="Offset X"></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model.number="test.offsetY" type="number" dense outlined
                label="Offset Y"></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model.number="test.lineFactor" type="number" step="0.01" dense outlined
                label="Factor de línea"></v-text-field>
            </v-col>

            <template v-if="test.bankType !== 'codevi'">
              <v-col cols="12">
                <div class="text-caption grey--text">
                  Solo la fecha (1/100 de pulgada). Valores negativos: izquierda / arriba;
                  positivos: derecha / abajo. -10 mueve 2.54 mm. 0 conserva la posición de la plantilla.
                </div>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model.number="test.dateOffsetX" type="number" min="-100" max="100" step="1" dense outlined
                  label="Fecha: ajuste horizontal"></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model.number="test.dateOffsetY" type="number" min="-100" max="100" step="1" dense outlined
                  label="Fecha: ajuste vertical"></v-text-field>
              </v-col>
            </template>

            <v-col cols="12">
              <div class="text-caption grey--text mb-1">
                Tamaño de página (1/100"). <b>Alto = alto físico del cheque</b>: clave para que el 2º cheque
                no se corra. Ancho 0 = usa el de la impresora.
                700 equivale a 7 pulgadas (177.8 mm); mide entre perforaciones antes de guardar.
                Prueba primero 2, luego 10 y finalmente 50 formularios sin valor.
                Si el error aumenta por cheque, corrige el alto del papel, no el offset Y.
              </div>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model.number="test.pageHeight" type="number" dense outlined
                label="Alto de página (alto del cheque)"></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model.number="test.pageWidth" type="number" dense outlined
                label="Ancho de página (0 = automático)"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-btn text color="primary" :loading="calibrationSaving" :disabled="testPrinting" @click="saveCalibration">
            <v-icon left>save</v-icon> Guardar calibración
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="secondary" :loading="testPrinting" @click="printTest">
            <v-icon left>print</v-icon> Imprimir prueba
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog transition="slide-x-transition" v-model="dialog" width="900px">
      <v-card style="background-color: #f4f5fa">
        <v-card-title>
          <v-row justify="end" class="pa-4">
            <v-btn @click="dialog = false" icon dark>
              <v-icon color="black">mdi-close</v-icon>
            </v-btn>
          </v-row>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row justify="center" v-if="dialog">
              <span class="text-h4" v-if="lastData"> Nueva secuencia </span>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="init_sequence"
                  type="number"
                  dense
                  outlined
                  label="Inicio de secuencia"
                  hint="Puedes cambiarlo (ej. 4000)"
                  persistent-hint
                  color="cyanText"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="finish_sequence"
                  dense
                  outlined
                  label="Final de secuencia"
                  color="cyanText"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-row justify="center" class="mb-4">
            <v-btn @click="save" color="primary" outlined>
              <v-icon>save</v-icon> Guardar
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment";
import check_print from "@/services/check_print.js";
import PrinterPicker from "@/components/CxP/PrinterPicker.vue";

// Beneficiarios de prueba: cortos, normales y muy largos (para ver si pisan el monto).
const SAMPLE_NAMES = [
  "ANA PEREZ",
  "PEDRO ANTONIO VELEZ CORNIEL",
  "FERRETERIA EL MARTILLO SRL",
  "DISTRIBUIDORA CARIBE, S.A.",
  "TRANSPORTE NORTE EIRL",
  "MARIA DE LOS ANGELES RODRIGUEZ DE LA CRUZ",
  "COMPAÑIA DOMINICANA DE TELEFONOS, S.A.",
  "SERVICIOS INDUSTRIALES Y MANTENIMIENTO DEL CIBAO, S.R.L.",
  "JOSE LUIS NUÑEZ",
  "EDENORTE DOMINICANA, S.A.",
  "TEXTILES Y ACCESORIOS INTERNACIONALES DEL ATLANTICO, S.A.S.",
  "LUIS GOMEZ",
];
const SAMPLE_ADDRESSES = [
  "AV. 27 DE FEBRERO #45, SANTIAGO, R.D.",
  "C/ DUARTE #12, LA VEGA, R.D.",
  "ZONA FRANCA INDUSTRIAL, NAVE 7, SANTIAGO DE LOS CABALLEROS, R.D.",
  "AUT. DUARTE KM 9 1/2, SANTO DOMINGO OESTE, R.D.",
];
export default {
  components: { PrinterPicker },
  data: () => ({
    loading: false,

    // --- Prueba / calibración de impresora ---
    testDialog: false,
    testPrinting: false,
    calibrationSaving: false,
    printApiUrl: "",
    test: {
      bankType: "popular", // = check_template: popular (DOP/español) | codevi (USD/inglés)
      printerName: "PRINTERCHEQUES", // impresora física de la cuenta
      copies: 2, // cantidad de cheques (páginas) -> 2+ para probar el avance de página
      rows: 3, // cantidad de filas de facturas por cheque
      amountMin: 500, // rango del monto al azar de cada factura de prueba
      amountMax: 250000,
      offsetX: 0,
      offsetY: 0,
      dateOffsetX: 0,
      dateOffsetY: 0,
      fieldOffsets: {}, // ajuste por campo guardado en la cuenta: { campo: { x, y } }
      lineFactor: 1.6168,
      pageWidth: 0, // 0 = ancho por defecto de la impresora
      pageHeight: 700, // alto físico del cheque (1/100") -> clave para múltiples cheques
    },
    bankTypes: [
      { text: "Banco Popular (DOP · español)", value: "popular" },
      { text: "BANRESERVAS DOP LECHUZA", value: "banreservas" },
      { text: "Codevi (USD · inglés)", value: "codevi" },
    ],

    all_sequence_account: [],
    headers: [
      {
        text: "Secuencia cheque",
        align: "start",

        value: "sequence",
      },
      {
        text: "Entidad",
        value: "entity_name",
      },
      {
        text: "Id transaction",
        value: "payment_transaction_id",
      },
      {
        text: "Secuencia Transaction",
        value: "payment_transaction_sequence",
      },

      { text: "Actions", value: "actions", sortable: false },
    ],
    dialog: false,
    search: "",

    init_sequence: 0,
    finish_sequence: 0,

    hasData: false,

    lastData: null,

    editedIndex: -1,
    editedItem: [],
  }),

  computed: {},

  watch: {},

  created() {
    // this.initialize();
  },

  methods: {
    async openTestPrinter() {
      try {
        await this.loadAccountConfig();
        this.printApiUrl = localStorage.getItem("print_api_url") || "";
        this.testDialog = true;
      } catch (error) {
        this.$toast.error(error.message || "No se pudo cargar la configuración de la cuenta.");
      }
    },

    // Carga la config de impresión de la cuenta seleccionada desde la BD.
    // Si no hay cuenta seleccionada, usa el fallback de localStorage.
    async loadAccountConfig() {
      const business_unit_id = this.lastData && this.lastData.business;
      const account_id = this.lastData && this.lastData.accountBank;
      if (business_unit_id && account_id) {
        try {
          const res = await this.api_Post("humanResource/getBusinessAccountPrinterConfig", {
            business_unit_id,
            account_id,
          });
          if (!res || res.status !== 200) {
            throw new Error("No se pudo cargar la configuración de la cuenta. Revisa el backend y la migración de fecha.");
          }
          if (res.status === 200) {
            const c = await res.json();
            if (c) {
              this.test.bankType = c.check_template || "popular";
              this.test.printerName = c.printer_name || "PRINTERCHEQUES";
              this.test.offsetX = Number(c.print_offset_x) || 0;
              this.test.offsetY = Number(c.print_offset_y) || 0;
              this.test.dateOffsetX = Number(c.print_date_offset_x) || 0;
              this.test.dateOffsetY = Number(c.print_date_offset_y) || 0;
              this.test.fieldOffsets = check_print.normalizeFieldOffsets(this.test.bankType, c.print_field_offsets);
              this.test.lineFactor = Number(c.print_line_factor) || 1.6168;
              this.test.pageWidth = Number(c.print_page_width) || 0;
              this.test.pageHeight = Number(c.print_page_height) || 700;
              return;
            }
          }
        } catch (e) {
          console.error(e);
          throw e;
        }
      }
      this.loadCalibration(); // fallback local
    },

    // URL del servicio de impresión para ESTE equipo (localStorage).
    savePrintApiUrl() {
      try {
        const base = this.set_print_api_base(this.printApiUrl);
        this.$toast.success(`Servicio de impresión: ${base}`);
        if (this.$refs.printerPicker) this.$refs.printerPicker.refresh();
      } catch (error) {
        this.$toast.error(error.message);
      }
    },

    loadCalibration() {
      const cal = check_print.getCalibration(this.test.bankType);
      this.test.offsetX = cal.offsetX;
      this.test.offsetY = cal.offsetY;
      this.test.dateOffsetX = cal.dateOffsetX;
      this.test.dateOffsetY = cal.dateOffsetY;
      this.test.fieldOffsets = cal.fieldOffsets || {};
      this.test.lineFactor = cal.lineFactor;
      this.test.pageWidth = cal.pageWidth;
      this.test.pageHeight = cal.pageHeight;
    },

    async saveCalibration() {
      if (this.calibrationSaving || this.testPrinting) return;
      this.calibrationSaving = true;
      try {
        const cal = check_print.validateCalibration(this.test.bankType, this.test);
        const business_unit_id = this.lastData && this.lastData.business;
        const account_id = this.lastData && this.lastData.accountBank;
        if (business_unit_id && account_id) {
          const res = await this.api_Post("humanResource/businessAccountPrinterConfig", {
            business_unit_id,
            account_id,
            printer_name: this.test.printerName,
            check_template: this.test.bankType,
            print_offset_x: cal.offsetX,
            print_offset_y: cal.offsetY,
            print_date_offset_x: cal.dateOffsetX,
            print_date_offset_y: cal.dateOffsetY,
            print_field_offsets: cal.fieldOffsets,
            print_line_factor: cal.lineFactor,
            print_page_width: cal.pageWidth,
            print_page_height: cal.pageHeight,
            print_max_invoices: check_print.MAX_INVOICES_PER_CHECK,
          });
          const saved = res ? await res.json() : null;
          if (!res || res.status !== 200 || !saved || !saved.ok || !saved.updated) {
            throw new Error((saved && saved.error) || "No se pudo guardar la configuración de la cuenta.");
          }
          // Confirmar los valores devueltos por UPDATE RETURNING: un backend anterior
          // puede responder 200 y omitir los campos nuevos sin guardarlos.
          const config = saved.config;
          if (!config || config.print_date_offset_x == null || config.print_date_offset_y == null ||
              !Number.isFinite(Number(config.print_date_offset_x)) || !Number.isFinite(Number(config.print_date_offset_y)) ||
              Math.abs(Number(config.print_date_offset_x) - cal.dateOffsetX) > 0.0051 ||
              Math.abs(Number(config.print_date_offset_y) - cal.dateOffsetY) > 0.0051) {
            throw new Error("No se confirmó el guardado de la fecha. Actualiza el backend y aplica la migración de fecha.");
          }
          let savedFields;
          try {
            savedFields = check_print.normalizeFieldOffsets(this.test.bankType, config.print_field_offsets);
          } catch (e) {
            savedFields = null;
          }
          if (config.print_field_offsets === undefined || !savedFields ||
              JSON.stringify(savedFields) !== JSON.stringify(cal.fieldOffsets)) {
            throw new Error("No se confirmó el guardado de los campos. Actualiza el backend y aplica la migración de ajustes por campo.");
          }
          this.test.dateOffsetX = Number(config.print_date_offset_x);
          this.test.dateOffsetY = Number(config.print_date_offset_y);
          this.test.fieldOffsets = savedFields;
          this.$toast.success("Configuración y posiciones de los campos guardadas en la cuenta");
        } else {
          check_print.saveCalibration(this.test.bankType, cal);
          this.$toast.success("Calibración guardada (local — selecciona una cuenta para guardarla en BD)");
        }
      } catch (error) {
        this.$toast.error(error.message || "Error al guardar la configuración");
      } finally {
        this.calibrationSaving = false;
      }
    },

    // Cheques de prueba con datos variados: nombres de distinto largo y montos al azar
    // dentro del rango, para ver cómo caen montos chicos/grandes y nombres largos.
    buildSampleCheques() {
      const copies = Number(this.test.copies);
      const rows = Number(this.test.rows);
      if (!Number.isInteger(copies) || copies < 1 || copies > 50 ||
          !Number.isInteger(rows) || rows < 0 || rows > 100) {
        throw new Error("Usa de 1 a 50 cheques y de 0 a 100 filas enteras.");
      }
      const min = Number(this.test.amountMin);
      const max = Number(this.test.amountMax);
      if (!Number.isFinite(min) || !Number.isFinite(max) || min <= 0 || max < min || max > 100000000) {
        throw new Error("Revisa el rango de montos: mínimo mayor que 0 y máximo mayor o igual al mínimo.");
      }
      const pick = (list) => list[Math.floor(Math.random() * list.length)];
      const randomAmount = () => Math.round((min + Math.random() * (max - min)) * 100) / 100;
      const round2 = (n) => Math.round(n * 100) / 100;

      const cheques = [];
      for (let i = 0; i < copies; i++) {
        const InvoiceDetails = [];
        for (let r = 0; r < rows; r++) {
          const invoiceAmount = randomAmount();
          // Algunas facturas con pago parcial o descuento, para ver todas las columnas llenas.
          const amountPaid = Math.random() < 0.2 ? round2(invoiceAmount * (0.3 + Math.random() * 0.6)) : invoiceAmount;
          const discountTaken = Math.random() < 0.15 ? round2(amountPaid * 0.02) : 0;
          InvoiceDetails.push({
            // Mismo formato real que produce ViewTransactionsCxP: No. de factura largo.
            VoucherNo: pick(["FCLM", "FCGM", "B01", "E31"]) + String(Math.floor(Math.random() * 1e10)).padStart(10, "0"),
            invoiceNo: "PRUEBA",
            invoiceDate: moment().subtract(Math.floor(Math.random() * 90), "days").format("DD/MM/YYYY"),
            invoiceAmount,
            amountPaid,
            discountTaken,
            netCheckAmount: round2(amountPaid - discountTaken),
          });
        }
        const amount = rows > 0
          ? round2(InvoiceDetails.reduce((sum, inv) => sum + inv.netCheckAmount, 0))
          : randomAmount();
        cheques.push({
          chequeDate: moment().format("DD/MM/YYYY"),
          chequeNumber: String(900000 + i),
          SupplierId: String(10000 + Math.floor(Math.random() * 90000)),
          SupplierName: pick(SAMPLE_NAMES),
          SupplierAddress: pick(SAMPLE_ADDRESSES),
          amount: String(amount),
          InvoiceDetails,
        });
      }
      return cheques;
    },

    async printTest() {
      if (this.testPrinting) return;
      this.testPrinting = true;
      try {
        const opts = {
          offsetX: this.test.offsetX,
          offsetY: this.test.offsetY,
          dateOffsetX: this.test.dateOffsetX,
          dateOffsetY: this.test.dateOffsetY,
          fieldOffsets: this.test.fieldOffsets,
          lineFactor: this.test.lineFactor,
          pageWidth: this.test.pageWidth,
          pageHeight: this.test.pageHeight,
        };
        const pages = check_print.buildCheckPages(this.test.bankType, this.buildSampleCheques(), opts);
        const response = await this.api_print_render({
          PrinterName: this.test.printerName || "PRINTERCHEQUES",
          Pages: pages,
          PageWidth: Math.round(Number(this.test.pageWidth)) || 0,
          PageHeight: Math.round(Number(this.test.pageHeight)) || 0,
        });
        if (response && response.status === 200) {
          this.$toast.success("Prueba enviada a la impresora");
          const warning = check_print.paperWarning(response.result, this.test.pageHeight);
          if (warning) this.$toast.warning(warning, { timeout: 20000 });
        } else {
          this.$toast.error("No se pudo imprimir la prueba");
        }
      } catch (error) {
        console.error(error);
        this.$toast.error(error.message || "Error al imprimir la prueba");
      }
      this.testPrinting = false;
    },

    getStatusColor(status_id) {
      const colors = {
        1: "orange",
        2: "green",
        3: "red",
        4: "red",
      };
      return colors[status_id] || "grey";
    },

    goToTransaction(id) {
      const route = this.$router.resolve({
        name: "ViewTransactionsCxP",
        params: { id: id },
      });
      window.open(route.href, "_blank");
    },

    async showAddSequence() {
      if (this.lastData.accountBank == null) {
        this.$toast.warning("Selecciona una cuenta de banco");
        return;
      }
      let result = await this.api_Post("transactions/get_last_sequence_account_bank", {
        id: this.lastData.accountBank,
      });
      if (result.status == 200) {
        let data = await result.json();
        if (data.length == 0) {
          this.init_sequence = 1;
          this.finish_sequence = null;
        } else {
          let finish = parseFloat(data[0].sequence) + 1;
          this.init_sequence = finish;

          this.finish_sequence = null;
        }
      }
      this.dialog = true;
    },

    async get_data(data) {
      this.loading = true;
      this.lastData = data;

      if (data.accountBank != null) {
        let resultTransactions = await this.api_Post(
          "transactions/get_sequence_account_bank",
          {
            id: data.accountBank,
          }
        );
        if (resultTransactions.status == 200) {
          this.all_sequence_account = [];
          this.all_sequence_account = await resultTransactions.json();
        }
      }

      this.loading = false;
    },

    async save() {
      if (this.lasData != null) {
        if (this.lasData.business === null) {
          this.$toast.warning("Debes elegir una unidad de negocio!");
          return;
        }

        if (this.lasData.accountBank === null) {
          this.$toast.warning("Debes elegir una cuenta de banco!");
          return;
        }
      }

      let data = {
        init_sequence: this.init_sequence,
        finish_sequence: this.finish_sequence,
        account_bank: this.lastData.accountBank,
        business_unit_id: this.lastData.business,
      };

      const responseRequest = await this.api_Post("transactions/generate_check", data);
      if (responseRequest.status == 200) {
        let data = await responseRequest.json();
        this.get_data(this.lastData);
        this.$toast.success("agregado con exito!");
        this.dialog = false;
      } else {
        this.$toast.error("error al registrar la transacion!");
      }
    },
  },
};
</script>
